import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[12px] font-medium uppercase tracking-wide transition-colors",
  {
    variants: {
      variant: {
        default: "bg-muted text-muted-foreground border border-border",
        primary: "bg-primary-soft text-primary-soft-foreground",
        warm: "bg-warm-soft text-warm-soft-foreground border border-[color-mix(in_oklab,var(--color-warm)_30%,transparent)]",
        success: "bg-[color-mix(in_oklab,var(--color-success)_15%,transparent)] text-[var(--color-success)] border border-[color-mix(in_oklab,var(--color-success)_25%,transparent)]",
        warning: "bg-[color-mix(in_oklab,var(--color-warning)_22%,transparent)] text-[var(--color-warning)] border border-[color-mix(in_oklab,var(--color-warning)_35%,transparent)]",
        info: "bg-[color-mix(in_oklab,var(--color-info)_15%,transparent)] text-[var(--color-info)] border border-[color-mix(in_oklab,var(--color-info)_25%,transparent)]",
        destructive: "bg-destructive-soft text-destructive border border-[color-mix(in_oklab,var(--color-destructive)_30%,transparent)]",
        outline: "border border-border-strong text-foreground",
      },
      size: {
        default: "h-5",
        sm: "h-[18px] px-1.5",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant, size, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ variant, size }), className)} {...props} />
));
Badge.displayName = "Badge";
